import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PageTransition } from '../transitions/PageTransition';
import { WorkHero } from './WorkHero';
import { WorkFilters } from './WorkFilters';
import { WorkGrid } from './WorkGrid';
import { useCursorContext } from '../../hooks/useCursorContext';
import { SEOHead } from '../seo/SEOHead';

export function WorkPage() {
  const { setCursorState } = useCursorContext();

  return (
    <PageTransition>
      <SEOHead
        title="Arbeiten"
        description="Portfolio mit 50+ Projekten für DAX-Unternehmen wie Mercedes-Benz und E.ON. React, Vue.js, TypeScript und UX/UI Design."
        path="/work"
      />
      <div className="min-h-screen bg-[#0a0a0a]">
        {/* Back Link (visible on scroll) */}
        <div className="fixed top-24 left-8 md:left-12 z-40">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/40 hover:text-emerald-500 transition-colors group"
            onMouseEnter={() => setCursorState('hovering')}
            onMouseLeave={() => setCursorState('default')}
          >
            <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            <span className="text-xs tracking-wider uppercase">Zurück</span>
          </Link>
        </div>

        {/* Hero */}
        <WorkHero />

        {/* Filters */}
        <WorkFilters />

        {/* Project Grid */}
        <WorkGrid />

        {/* Footer */}
        <footer className="py-12 px-8 md:px-12 lg:px-24 border-t border-white/10">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
            <span className="text-xs text-white/20">
              © {new Date().getFullYear()} NK Design
            </span>
            <span className="text-xs text-white/20">Köln, Deutschland</span>
          </div>
        </footer>
      </div>
    </PageTransition>
  );
}
